import "./App.css";
import { RouterProvider, useNavigate } from "react-router-dom";
import router from "./App/Routes";
import { Toaster } from "react-hot-toast";
import { useEffect } from "react";

function App() {
  // useEffect(() => {
  //   window.location.href = "https://pharmasolo.com";
  // }, []);

  return (
    <div className="App">
      <div className="text-regular">
        <Toaster />
        <RouterProvider router={router} />
      </div>
    </div>
  );
}

export default App;
